import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from '@capacitor/dialog';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { LoginService } from 'src/app/services/login.service';
import { MyEventServices } from 'src/app/services/my-event.service';
import { ProfileService } from 'src/app/services/profile.service';
import { Profile } from 'src/models/profile';

@Component({
  selector: 'app-family',
  templateUrl: './family.component.html',
  styleUrls: ['./family.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, PipeModule]
})
export class FamilyComponent implements OnInit, OnDestroy {
  @Input() profileId: number = 0;
  @Input() familyId: number = 0;
  @Input() showToolbar = false;
  lstFamily: Profile[] = [];
  isFamilyMember = false;
  subscriptions: Subscription[] = [];

  constructor(private profileService: ProfileService, public userService: LoginService, private myEventService: MyEventServices, private modalCtrl: ModalController) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    //this.myEventService.loadingEvent.emit(true);
    this.subscriptions.push(this.profileService.getProfilesByDataType(this.profileId, 'MyFamily').subscribe(result => {
      this.myEventService.loadingEvent.emit(false);
      this.lstFamily = result;
      this.isFamilyMember = result.findIndex(x => x.ProfileId === this.userService.currentUser?.ProfileId) > -1;
    }));
  }

  addFamilyMember() {
    this.profileService.closeProfileEvent.emit(0);
    this.profileService.showProfile(0, this.familyId, true, false);
  }

  showFamilyMember(member: Profile) {
    if (this.isFamilyMember === true || this.userService.currentUser?.IsAdministrator === true) {
      this.profileService.closeProfileEvent.emit(0);
      this.profileService.showProfile(member.ProfileId, this.familyId, false, false);
    }
  }

  deleteFamilyMember(profile: Profile) {
    Dialog.confirm({
      title: 'Delete Profile?',
      message: `Are you sure you want to delete ${profile.ProfileName}'s profile?`
    }).then(response => {
      if (response.value === true) {
        this.subscriptions.push(this.profileService.deleteProfile(profile.ProfileId).subscribe(result => {
          if (result && result === true) {
            this.myEventService.showToast('success', 'Account deleted', 'Accounted deleted successfuly');
            let index = this.lstFamily.findIndex(f => f.ProfileId === profile.ProfileId);
            this.lstFamily.splice(index, 1);
          }
        }));
      }
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
